import { Component, ElementRef, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationContextService, ConfirmationModalComponent, ProductService, RolePermissionService, UtilitiesService, ProductRequestPostSupersedeModel, ProductRequestPostSupersedeItemModel, IProductCoreModel, ProductOptionService, ProductPhotosService } from 'lib-core-shared';
import { MESSAGES } from '../../constants';
import { PageBaseDirective } from '../../directives/page-base.directive';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss']
})
export class ProductSummaryComponent extends PageBaseDirective<any> {
  @ViewChild('superceded') public superceded!: TemplateRef<any>;
  @Input() showPartDetails!: boolean;
  @Input() productMasterStatuses!: any; //todo - create a real model for this
  @Input() productId!: string;
  @Input() showDataDashboard!: boolean | undefined;
  @Input() showSalesDashboard!: boolean | undefined;
  public summary!: any; //todo - create a real model for this
  private updatePageSubjectSubsciption$!: Subscription;
  partNumber?: string;
  id: any;
  public groupForm!: FormGroup;
  public ngbModalOption: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'lg'
  }
  public product: IProductCoreModel | undefined;
  modalRef: any;
  branch: string;
  currencyCode: string = this.productService.getCurrencyCode();

  canDepotDenyProduct: boolean = false;
  canFreezeProduct: boolean = false;
  canMakeProductNotAvailable: boolean = false;
  canSupersedeProduct: boolean = false;
  canMakeProductAvailable: boolean = false;
  canTurnDownProduct: boolean = false;

  @ViewChild('imageModal') public imageModal!: ElementRef;
  imageUrl750px?: string;
  modalBusy!: boolean;
  showIntraGroupPrice: boolean = this.applicationContext.getBrandContextFromUrl() == 'MOSS' ? true : false;

  constructor(public productService: ProductService,
    public roleService: RolePermissionService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public productOptionService: ProductOptionService,
    public modalService: NgbModal,
    public utilitiesService: UtilitiesService,
    public applicationContext: ApplicationContextService,
    private productPhotosService: ProductPhotosService
  ) {
    super(activatedRoute, router, modalService, utilitiesService, roleService, applicationContext);

    this.activatedRoute.params.subscribe(p => {
      this.productId = p.id;
    });

    this.branch = this.applicationContext.getBranchCodeFromUrl();
    this.canDepotDenyProduct = this.roleService.userHasPermission('ProductManagement.Product.DepotDeny');
    this.canFreezeProduct = this.roleService.userHasPermission('ProductManagement.Product.Freeze');
    this.canMakeProductNotAvailable = this.roleService.userHasPermission('ProductManagement.Product.NotAvailable');
    this.canSupersedeProduct = this.roleService.userHasPermission('ProductManagement.Product.Supersede');
    this.canMakeProductAvailable = this.roleService.userHasPermission('ProductManagement.Product.Reinstate');
    this.canTurnDownProduct = this.roleService.userHasPermission('ProductManagement.Product.Turndown');
  }

  ngAfterContentInit(): void {
    this.updatePageSubjectSubsciption$ = this.utilitiesService.updatePageSubject.subscribe(x => {
      this.response$ = this.productService.summary(this.productId);
      this.response$?.subscribe((result) => {
        this.summary = result;
        this.isBusy = false;

        if (this.imageUrl750px && result.imageUrl) {
          let imageOne = this.imageUrl750px.split('/').pop();
          let imageTwo = result.imageUrl.split('/').pop();
          if (imageOne != imageTwo) {
            this.imageUrl750px = undefined;
          }
        } 
      });
    })

    if (this.broadCastSubmssion$) {
      this.broadCastSubmssion$.subscribe(x => {
        this.response$ = this.productService.summary(this.productId);
        this.getDetail();
        this.response$?.subscribe((result) => {
          this.summary = result;
          this.partNumber = result?.partNumber;
          this.isBusy = false;
        });
      });
    }
  }

  // public (changes: SimpleChanges): void {

    // TODO: Product Summary
    // if (latest.currentValue) {
    //   this.id = latest.currentValue;
    //   this.productService.master(this.id + '').subscribe(x => {
    //     this.summary = x;
    //     this.isBusy = false;
    //   });
    //   this.response$ =  this.customerDetailService.getSummary(latest.currentValue + '');
    //   this.getDetail();
    //   this.submittedEvent.subscribe(x => {
    //     this.response$?.subscribe((result) => {
    //       this.summary = result;
    //       this.isBusy = false;
    //     });
    //   });
    // }
  // }

  toggleShowPartDetails() {
    this.showPartDetails = !this.showPartDetails;
  }

  public categorisedClass(value: any): string {
    const disableButton = function() {
      document.getElementById(value.code.toString())?.setAttribute('disabled', 'disabled');
    } 

    if (value.name === 'Depot Denied') {
      if (!this.canDepotDenyProduct) {
        disableButton();
      }
      return value.code; // D
    } else if (value.name === 'Frozen') {
      if (!this.canFreezeProduct) {
        disableButton();
      }
      return value.code; // F
    } else if (value.name === 'Not Available') {
      if (!this.canMakeProductNotAvailable) {
        disableButton();
      }
      return value.code; // N
    } else if (value.name === 'Superseded') {
      if (!this.canSupersedeProduct) {
        disableButton();
      }
      return value.code; // S
    } else if (value.name === 'Available') {
      if (!this.canMakeProductAvailable) {
        disableButton();
      }
      return value.code; // Y
    }  else if (value.name === 'Turned Down') {
      if (!this.canTurnDownProduct) {
        disableButton();
      }
      return value.code; // Z
    } else {
      return 'default';
    }
  }

  public processStatus(value: any) {
    if (value.name === 'Frozen') {
      this.freeze();
    } else if (value.name === 'Turned Down') {
      this.turnDown();
    } else if (value.name === 'Available') {
      this.makeAvailable();
    } else if (value.name === 'Superseded') {
      this.supersede();
    } else {
      throw Error('Not Implemented');
    }
  }

  public supersede() {
    const callBack:any = () => {
      let model = {
        id: this.productId,
        supersession: [],
      } as ProductRequestPostSupersedeModel;

      for (let control of ((this.modalRef.componentInstance.form.controls.supecededProducts) as FormArray).controls) {
        const grp = control as FormGroup;
        let item = {} as ProductRequestPostSupersedeItemModel;
        item.quantity = grp.controls.quantity.value;
        item.replacementPartNumber = grp.controls.partNumber.value;
        model.supersession.push(item);
      }

      return this.productService.supersede(model);
    };

    this.modalRef = this.modalService.open(ConfirmationModalComponent, this.ngbModalOption);
    this.modalRef.componentInstance.title = `Supercede ${this.partNumber}`;
    this.modalRef.componentInstance.cancelButtonText = 'Cancel';
    this.modalRef.componentInstance.saveButtonText = 'Save Supersession';
    this.modalRef.componentInstance.classTitle = "text-supersede";
    this.modalRef.componentInstance.template = this.superceded;
    this.modalRef.componentInstance.classButton = "bg-supersede";
    this.modalRef.componentInstance.callBack = callBack;
    this.modalRef.componentInstance.statusEmitter.subscribe((outcome: any) => {
      if (outcome.statusCode === 'TS') {
        this.modalRef.componentInstance.successMessage = `${this.partNumber} will automatically be superseded when it no longer appears 
          on CID notes, sales and purchase orders`
      } else {
        this.modalRef.componentInstance.successMessage = `${this.partNumber} has successfully been superseded`
      }
    })
    this.modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {     
      this.productOptionService.getProductMasterStatuse(this.productId).subscribe(x => this.productMasterStatuses = x.statuses);
      this.utilitiesService.updatePageSubject.next(null);
      this.modalRef.close();
    });
  }

  public turnDown() {
    const callBack = () => {
      return this.productService.turnDown(this.productId);
    };

    this.modalRef = this.modalService.open(ConfirmationModalComponent);
    this.modalRef.componentInstance.title = `Turn Down ${this.partNumber}`;
    this.modalRef.componentInstance.classTitle = "text-turndown";
    this.modalRef.componentInstance.classButton = "bg-turndown";
    this.modalRef.componentInstance.body = `${MESSAGES.CONFIRMATION_TURNDOWN} ${this.partNumber}?`;
    this.modalRef.componentInstance.callBack = callBack;
    this.modalRef.componentInstance.statusEmitter.subscribe((outcome: any) => {
      if (outcome.statusCode === 'TZ') {
        this.modalRef.componentInstance.successMessage = `${this.partNumber} will automatically be turned down when it no longer appears 
          on CID notes, sales and purchase orders`
      } else {
        this.modalRef.componentInstance.successMessage = `${this.partNumber} has successfully been turned down`
      }
    })
    this.modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
      this.productOptionService.getProductMasterStatuse(this.productId).subscribe(x => this.productMasterStatuses = x.statuses);
      this.utilitiesService.updatePageSubject.next(null);
      this.modalRef.close();
    });
  }

  public freeze() {
    const callBack = () => {
      return this.productService.freeze(this.productId);
    };
    
    this.modalRef = this.modalService.open(ConfirmationModalComponent);
    this.modalRef.componentInstance.title = `Freeze ${this.partNumber}`;
    this.modalRef.componentInstance.successMessage = `${this.partNumber} has been successfully frozen`;
    this.modalRef.componentInstance.classTitle = "text-freeze";
    this.modalRef.componentInstance.classButton = "bg-freeze";
    this.modalRef.componentInstance.body = `${MESSAGES.CONFIRMATION_FREEZ} ${this.partNumber}?`;
    this.modalRef.componentInstance.callBack = callBack;
    this.modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
      this.productOptionService.getProductMasterStatuse(this.productId).subscribe(x => this.productMasterStatuses = x.statuses);
      this.utilitiesService.updatePageSubject.next(null);
      this.modalRef.close();
    });
  }

  public makeAvailable() {
    const callBack = () => {
      return this.productService.makeAvailable(this.productId);
    };
    
    this.modalRef = this.modalService.open(ConfirmationModalComponent);
    this.modalRef.componentInstance.title = `Make ${this.partNumber} Available`;
    this.modalRef.componentInstance.successMessage = `${this.partNumber} has been made available`;
    this.modalRef.componentInstance.classTitle = "text-available";
    this.modalRef.componentInstance.classButton = "bg-available";
    this.modalRef.componentInstance.body = `Are you sure you want to make part number ${this.partNumber} available?`;
    this.modalRef.componentInstance.callBack = callBack;
    this.modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
      this.productOptionService.getProductMasterStatuse(this.productId).subscribe(x => this.productMasterStatuses = x.statuses);
      this.utilitiesService.updatePageSubject.next(null);
      this.modalRef.close();
    });
  }

  public assignForm(form: FormGroup) {
    this.modalRef.componentInstance.form = form;
  }

  ngOnDestroy(): void {
    if(this.updatePageSubjectSubsciption$) this.updatePageSubjectSubsciption$.unsubscribe();
  }

  public openImageModal() {
    if (this.productId && !this.imageUrl750px) {
      this.modalBusy = true;
      this.productPhotosService.get(parseInt(this.productId)).subscribe(res => {
        let defaultImage = res.filter(x => x.isDefault === true)[0];
        if (defaultImage) {
          this.imageUrl750px = defaultImage.watermarked?.imageUrl750px;
        }
        this.modalBusy = false;
      })
    }
    this.modalService.open(this.imageModal, {size: 'lg'});
  }

  get intraGroupPrice(): number {
    return this.productService.getIntraGroupPrice(this.summary.branchInfo.averageCostPrice)
  }
}